export const inboxKeys = {
	all: ["inbox"] as const,
	conversations: () => [...inboxKeys.all, "conversations"] as const,
	messages: (conversationId: string) => [...inboxKeys.all, "messages", conversationId] as const,
	participants: (conversationId: string) => [...inboxKeys.all, "participants", conversationId] as const,
	participantDetails: (participantId: string) => [...inboxKeys.all, "participant", participantId] as const,
	matchedCandidate: (channel: string, linkKey: string) =>
		[...inboxKeys.all, "candidate", channel, linkKey] as const,
	accounts: () => [...inboxKeys.all, "accounts"] as const,
	entityConversations: (entityType: string, entityId: string) =>
		[...inboxKeys.all, "entity", entityType, entityId] as const,
	savedMessages: (entityType: string, entityId: string) =>
		[...inboxKeys.all, "saved", entityType, entityId] as const,
};
